import {
  Button,
  Card,
  Col,
  ConfigProvider,
  message,
  Modal,
  Pagination,
  Row,
} from 'antd'
import React,{ useEffect, useRef, useState } from 'react'
import ADStyle from './article-detail.module.less'
import { useHistory, useParams,useLocation } from 'react-router-dom'
import MarkDownEditor, {
  mdParser,
} from '../../../component/MarkDownEditor/MarkDownEditor'
import katex from 'katex'
import MarkdownItKatex from '@iktakahiro/markdown-it-katex'
import DiscusItemStyle from '../../../component/DiscussItem/DiscussItem.module.less'
import { ReplyItem } from '../../../component/DiscussItem/ReplyItem'
import Cookies from 'js-cookie'
import { BACKEND_API_URL } from '../../../constants/constants'
import { sendHttpPostRequest } from '../../../api/http-request'
import zhCN from 'antd/lib/locale/zh_CN'
import Draggable from 'react-draggable'
import { SwapOutlined , MessageOutlined, ManOutlined, WomanOutlined} from '@ant-design/icons'
import emptyCourse from '../../../static/image/empty/queshengye-kecheng.png'

const emoji = require('markdown-it-emoji')

const ArticleDetail = (props) => {
  const history = useHistory()
  const params: any = useParams()
  const location = useLocation()
  const articleId = location?.search?.split('id=')[1]

  const articleContent = useRef()
  mdParser.use(MarkdownItKatex, { katex })
  mdParser.use(emoji)
  const [articleInfo, setArticleInfo] = useState(null as any)
  const [myAvatar, setMyAvatar] = useState(
    'static/image/avatar/default_avatar.png'
  ) // 我的头像
  const [editorVis, setEditorVis] = useState(false)
  const [myName, setMyName] = useState('') // 我的名字
  const [myArticleReply, setMyArticleReply] = useState('') // 我回复文章的内容

  const [replies, setReplies] = useState([] as any[])

  
  const [isAllRepliesVis, setIsAllRepliesVis] = useState(false)
  const [articleLoaded, setArticleLoaded] = useState(false) // 加载中
  const [uploadImageList, setUploadImageList] = useState([] as any[])
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const draggleRef = useRef<HTMLDivElement | null>(null)
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  const uploadOption = {
    name: 'community_picture',
    actionUrl: 'community/api/upload_picture/',
    uploadData: { sessionid: Cookies.get('sessionid') },
    uploadImageList: uploadImageList,
    setUploadImageList: setUploadImageList,
  }



  const add_link_target = ()=>{
    setTimeout(function(){
      const a_links = document.getElementsByTagName("a") //链接改为新弹出窗口效果
      for(let i=0; i < a_links.length;  i++){
          try{
            let href_ = a_links[i].getAttribute("href") as any
            if ( href_.indexOf('http') >= 0){
              a_links[i].setAttribute('target', '_blank');
            }
            
          }catch(error1){
            console.log(error1)
          }
        }
    }, 1500); //单位是毫秒

  }
  


  useEffect(() => {
    // editorStateInit()

    window.onload = function(){
      try{
        add_link_target()
      }catch(error){
        console.log(error)
      }
    } 

    queryArticleContent()
  }, [])

  /**
   * 查询文章内容
   */
  const queryArticleContent = () => {
    setArticleLoaded(false)
    sendHttpPostRequest(
      'community/api/query_post_by_id/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: articleId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
          // 成功
          setArticleInfo(response.query_content)
          queryArticleReplyList()
          setMyAvatar(response.query_content.my_avatar)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          window.location.href = '/community?tab=3'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 查询文章回复列表
   */
  const queryArticleReplyList = () => {
    sendHttpPostRequest(
      'community/api/query_post_reply_list/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: articleId,
        page: page.current,
        pagesize: pageSize.current,
      },
      (response: any) => {
        setArticleLoaded(true)
        message.destroy()
        if (response.code == -100) {
          // 未登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
          // 成功
          setReplies(response.query_list)
          setResultSum(response.total_sum)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          window.location.href = '/community?tab=3'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 查我的文章总数
   * @param url
   */
  const queryMyArticleCount = (url = 'community/api/query_my_post_count/') => {
    sendHttpPostRequest(
      url,
      {
        sessionid: Cookies.get('sessionid'),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          // window.location.href = '/login?next=community';
        } else if (response.code == 0) {
          // 成功
          setMyName(response.myself.name)
          setMyAvatar(response.myself.avatar)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/community'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 删除文章
   */
  const deleteArticle = () => {
    sendHttpPostRequest(
      'community/api/delete_post/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: articleId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
          // 成功
          message.success('删除文章成功')
          setTimeout(function () {
            window.location.href = '/community'
          }, 1000)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          window.location.href = '/community?tab=3'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 点赞文章
   */
  const praiseArticle = () => {
    if (articleInfo.praised) {
      articleInfo.praised_count -= 1
    } else {
      articleInfo.praised_count += 1
    }
    articleInfo.praised = !articleInfo.praised
    setArticleInfo(JSON.parse(JSON.stringify(articleInfo)))
    sendHttpPostRequest(
      'community/api/praise_post/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: articleId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
          // 成功
          message.success(response.message)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          window.location.href = '/community?tab=3'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const onEditorChange = (obj) => {
    let ta: any = document.getElementById('md-editor-id')!
    ta.addEventListener('input', (e) => {
      ta.style.height = '249px'
      ta.style.height = e.target.scrollHeight + 'px'
      // ta.style.height = ta.target!.scrollHeight + 'px';
    })
    setMyArticleReply(obj.text)
  }

  /**
   * 发布文章回复
   */
  const publishArticleReply = () => {
    sendHttpPostRequest(
      'community/api/publish_post_reply/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: articleId,
        content: myArticleReply,
        upload_image_list: JSON.stringify(uploadImageList),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == 0) {
          // 成功
          message.success('发表文章回复成功')
          // setTimeout(function () {
          setMyArticleReply('')
          setUploadImageList([])
          setEditorVis(false)
          queryArticleContent()
          // },1000)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          window.location.href = '/community?tab=3'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const onLikeChange = () => {
    if (articleInfo.is_my_like) {
      articleInfo.likes -= 1
    } else {
      articleInfo.likes += 1
    }
    articleInfo.is_my_like = !articleInfo.is_my_like
    setArticleInfo(JSON.parse(JSON.stringify(articleInfo)))
  }

  const editorStateInit = () => {
  }
  const onPageSizeChange = (newPage, newPageSize) => {
    page.current = newPage
    pageSize.current = newPageSize
    queryArticleReplyList()
  }

  return (
    <div className={ADStyle.detailMain}>
      <div style={{padding: '20px 30px 40px'}} className={ADStyle.articleCard}>
        <div className={ADStyle.articleTitle}>{articleInfo?.title}</div>
        <Row align={'middle'} style={{ marginBottom: '20px' }}>
          <Col>
            <img
              className={ADStyle.avatar}
              src={BACKEND_API_URL + articleInfo?.creator_avatar}
              alt=""
            />
          </Col>
          <Col style={{fontSize:16, fontWeight:500}}>{articleInfo?.creator_name}
          { articleInfo?.creator_sex == 3 && <WomanOutlined style={{marginLeft:5, fontSize:14, color:'#FF4D94'}} /> }
            { articleInfo?.creator_sex == 2 && <ManOutlined style={{marginLeft:5, fontSize:14, color:'#0091FF'}} />}

          <div style={{fontSize:14, fontWeight:400, color:'#666'}}>{articleInfo?.publish_time}</div></Col>
        </Row>
        <div
          className={ADStyle.mdContain}
          dangerouslySetInnerHTML={{
            __html: mdParser.render(String(articleInfo?.content)),
          }}
          ref={articleContent.current}
        ></div>

        <Row align="middle" justify="space-between">
          <Col>
            <span className={DiscusItemStyle.commentTime}>
              {articleInfo?.publish_time}
            </span>
          </Col>
          <Col flex={'300px'}>
            <div className={DiscusItemStyle.actionContain}>
              <div
                className={DiscusItemStyle.iconBtn}
                onClick={praiseArticle}
              >
                {articleInfo?.praised ? (
                  <span
                  style={{marginRight:3}}
                    className={
                      'iconfont icon_dianzan' +
                      ' ' +
                      DiscusItemStyle.heighLightBtnTextColor
                    }
                  ></span>
                ) : (
                  <span
                  style={{marginRight:3}}
                    className={
                      'iconfont icon_dianzan' +
                      ' ' +
                      DiscusItemStyle.grayBtnTextColor
                    }
                  ></span>
                )}{' '}
                {articleInfo?.praised_count <= 0 ? (
                  <span className={DiscusItemStyle.grayBtnTextColor}>赞</span>
                ) : (
                  <span className={DiscusItemStyle.commentTime}>
                    {articleInfo?.praised_count}
                  </span>
                )}
              </div>
              <div
                className={DiscusItemStyle.iconBtn}
                style={{ marginLeft: '20px' }}
                onClick={() => {
                  editorStateInit()
                  setEditorVis(!editorVis)
                }}
              >
                <span
                style={{marginRight:3}}
                  className={
                    'iconfont icon_huifu' +
                    ' ' +
                    DiscusItemStyle.grayBtnTextColor
                  }
                ></span>{' '}
                <span className={DiscusItemStyle.grayBtnTextColor}>回复</span>
                {articleInfo?.reply_count > 0 && (
                  <span className={DiscusItemStyle.grayBtnTextColor}>
                    ({articleInfo?.reply_count})
                  </span>
                )}
              </div>
              {articleInfo?.is_my && (
                <div
                  className={DiscusItemStyle.iconBtn}
                  onClick={() =>
                    history.push(`/community-article-edit/${articleId}`)
                  }
                >
                  <span
                  style={{marginRight:3}}
                    className={
                      'iconfont icon_bianji' +
                      ' ' +
                      DiscusItemStyle.grayBtnTextColor
                    }
                  ></span>
                  <span className={DiscusItemStyle.grayBtnTextColor}>编辑</span>
                </div>
              )}
              {articleInfo?.is_my && (
                <div className={DiscusItemStyle.iconBtn}>
                  <span
                  style={{marginRight:3}}
                    className={
                      'iconfont icon_shanchu' +
                      ' ' +
                      DiscusItemStyle.grayBtnTextColor
                    }
                  ></span>
                  <span
                    className={DiscusItemStyle.grayBtnTextColor}
                    onClick={() => {
                      setDeleteModalVisible(true)
                    }}
                  >
                    删除
                  </span>
                </div>
              )}
            </div>
          </Col>
        </Row>
        {editorVis && (
          <div className={DiscusItemStyle.editorContainer}>
            <Row align={'top'}>
              <Col flex={'100%'}>
                <MarkDownEditor
                  placeholder={`回复 ${articleInfo?.creator_name}:`}
                  onChange={onEditorChange}
                  uploadOption={uploadOption}
                  toolbar={[
                     'header',
                     'font-bold',
                    // 'emoji',
                     'font-italic',
                     'font-underline',
                     'font-strikethrough',
                     'list-unordered',
                     'list-ordered',
                     'block-quote',
                     'block-wrap',
                     'block-code-inline',
                     'block-code-block',
                     'table',
                    // 'image',
                    'img-upload',
                     'link',
                   'clear',
                     'mode-toggle',
                     'full-screen',
                    // 'tab-insert',
                  ]}
                />
                <Button
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    publishArticleReply()
                  }}
                  className={DiscusItemStyle.submitBtn}
                  type="primary"
                  style={{textShadow:'none', boxShadow:'none'}}
                >
                  发送
                </Button>
              </Col>
            </Row>
          </div>
        )}
        { replies.length == 0 && 
          <div className={ADStyle.replyContain}  style={{paddingTop:60, textAlign:'center', paddingBottom:60}}>
              <img src={emptyCourse} height={150} />
              <div style={{ marginTop:20, color: '#999999' }}>
                还没有回复，发表第一个回复吧
              </div>
          </div>
        }
        {replies.length > 0 && (
          <div className={ADStyle.replyContain} >
            <div>
              {replies.map((reply, rpIdx) => (
                <div key={rpIdx + 'reply'}  className = {ADStyle.first_level_reply}>
                  <ReplyItem
                    type={{ from: 'community' }}
                    reply={reply}
                    replies={replies}
                    setReplies={setReplies}
                    index={rpIdx}
                    editorStateInit={editorStateInit}
                    submitCallBack={queryArticleContent}
                  />
                  {reply.comment_list?.map((comment, cmIdx) => (
                    <div key={comment.id} style={{ marginLeft: '37px' }}>
                      <ReplyItem
                        type={{ from: 'community' }}
                        reply={comment}
                        replies={replies}
                        setReplies={setReplies}
                        index={cmIdx}
                        editorStateInit={editorStateInit}
                        submitCallBack={queryArticleContent}
                      />
                    </div>
                  ))}
                </div>
              ))}
              </div>
       
            

            <div style={{ margin: '20px auto', textAlign: 'center' }}>
              <ConfigProvider locale={zhCN}>
                <Pagination
                  total={resultSum}
                  current={page.current}
                  pageSize={pageSize.current}
                  onChange={onPageSizeChange}
                  hideOnSinglePage={true}
                  showSizeChanger={false}
                  showQuickJumper={false}
                />
              </ConfigProvider>
            </div>
          </div>
        )}
      </div> 

      <ConfigProvider locale={zhCN}>
        <Modal
          title={
            <div
              style={{
                width: '100%',
                cursor: 'move',
              }}
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false)
                }
              }}
              onMouseOut={() => {
                setDisabled(true)
              }}
              onFocus={() => {}}
              onBlur={() => {}}
              // end
            >
              提示
            </div>
          }
          open={deleteModalVisible}
          onOk={deleteArticle}
          onCancel={() => {
            setDeleteModalVisible(false)
          }}
          bodyStyle={{ height: '120px' }}
          destroyOnClose={true}
          width={350}
          modalRender={(modal) => (
            <div className={DiscusItemStyle.miniModal}>
              <Draggable
                disabled={disabled}
                bounds={bounds}
                onStart={(event, uiData) => onStart(event, uiData)}
              >
                <div ref={draggleRef}>{modal}</div>
              </Draggable>{' '}
            </div>
          )}
        >
          <div>确认删除文章吗？</div>
        </Modal>
      </ConfigProvider>
    </div>
  )
}

export default ArticleDetail
